var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1020:49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.001 5.25H7.07384C7.79877 5.25 8.38636 4.66246 8.38636 3.93748V3.5V1.31252C8.38636 0.587542 7.79877 0 7.07384 0H7.001C6.27606 0 5.68848 0.587542 5.68848 1.31252V3.5V3.93748C5.68848 4.66246 6.27606 5.25 7.001 5.25Z",
    fill: "#DBD9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5645 5.25H20.6374C21.3623 5.25 21.9499 4.66246 21.9499 3.93748V3.5V1.31252C21.9498 0.587542 21.3623 0 20.6373 0H20.5645C19.8395 0 19.252 0.587542 19.252 1.31252V3.5V3.93748C19.252 4.66246 19.8396 5.25 20.5645 5.25Z",
    fill: "#DBD9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.502 3.5H23.2623V3.93748C23.2623 5.38497 22.0848 6.56248 20.6373 6.56248H20.5644C19.1169 6.56248 17.9394 5.38497 17.9394 3.93748V3.5H9.69979V3.93748C9.69979 5.38497 8.52223 6.56248 7.07479 6.56248H7.00195C5.55446 6.56248 4.37695 5.38497 4.37695 3.93748V3.5H3.50195C1.56908 3.5 0.00195312 5.06713 0.00195312 7V24.5C0.00195312 26.4329 1.56908 28 3.50195 28H24.502C26.4348 28 28.002 26.4329 28.002 24.5V7C28.002 5.06713 26.4348 3.5 24.502 3.5ZM26.252 24.5C26.252 25.4655 25.4675 26.25 24.502 26.25H3.50195C2.53728 26.25 1.75195 25.4655 1.75195 24.5V10.5H26.252V24.5Z",
    fill: "#DBD9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00276 17.0268C8.19083 17.0268 9.15395 16.0636 9.15395 14.8756C9.15395 13.6875 8.19083 12.7244 7.00276 12.7244C5.81469 12.7244 4.85156 13.6875 4.85156 14.8756C4.85156 16.0636 5.81469 17.0268 7.00276 17.0268Z",
    fill: "#DBD9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0028 17.0268C15.1908 17.0268 16.154 16.0636 16.154 14.8756C16.154 13.6875 15.1908 12.7244 14.0028 12.7244C12.8147 12.7244 11.8516 13.6875 11.8516 14.8756C11.8516 16.0636 12.8147 17.0268 14.0028 17.0268Z",
    fill: "#DBD9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0028 17.0268C22.1908 17.0268 23.154 16.0636 23.154 14.8756C23.154 13.6875 22.1908 12.7244 21.0028 12.7244C19.8147 12.7244 18.8516 13.6875 18.8516 14.8756C18.8516 16.0636 19.8147 17.0268 21.0028 17.0268Z",
    fill: "#DBD9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00276 24.0268C8.19083 24.0268 9.15395 23.0636 9.15395 21.8756C9.15395 20.6875 8.19083 19.7244 7.00276 19.7244C5.81469 19.7244 4.85156 20.6875 4.85156 21.8756C4.85156 23.0636 5.81469 24.0268 7.00276 24.0268Z",
    fill: "#DBD9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0028 24.0268C15.1908 24.0268 16.154 23.0636 16.154 21.8756C16.154 20.6875 15.1908 19.7244 14.0028 19.7244C12.8147 19.7244 11.8516 20.6875 11.8516 21.8756C11.8516 23.0636 12.8147 24.0268 14.0028 24.0268Z",
    fill: "#DBD9D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0028 24.0268C22.1908 24.0268 23.154 23.0636 23.154 21.8756C23.154 20.6875 22.1908 19.7244 21.0028 19.7244C19.8147 19.7244 18.8516 20.6875 18.8516 21.8756C18.8516 23.0636 19.8147 24.0268 21.0028 24.0268Z",
    fill: "#DBD9D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1020:49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.00195312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1cd91e92.svg";
export { ForwardRef as ReactComponent };